import { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    // Check localStorage first, default to 'light'
    if (typeof window !== 'undefined') {
      return localStorage.getItem('usg-theme') || 'light';
    }
    return 'light';
  });

  useEffect(() => {
    const root = document.documentElement;
    
    if (theme === 'dark') {
      root.classList.add('dark');
      root.style.setProperty('--usg-bg', '#050505');
      root.style.setProperty('--usg-fg', '#F0F0F0');
      root.style.setProperty('--usg-primary', '#00F0FF');
      root.style.setProperty('--usg-primary-dim', 'rgba(0, 240, 255, 0.1)');
      root.style.setProperty('--usg-secondary', '#FF5F1F');
      root.style.setProperty('--usg-secondary-dim', 'rgba(255, 95, 31, 0.1)');
      root.style.setProperty('--usg-accent', '#39FF14');
      root.style.setProperty('--usg-surface', '#121212');
      root.style.setProperty('--usg-surface-highlight', '#1E1E1E');
      root.style.setProperty('--usg-border', '#2A2A2A');
      root.style.setProperty('--skytec-bg', '#050505');
      root.style.setProperty('--skytec-fg', '#F0F0F0');
      root.style.setProperty('--skytec-primary', '#00F0FF');
      root.style.setProperty('--skytec-primary-dim', 'rgba(0, 240, 255, 0.1)');
      root.style.setProperty('--skytec-secondary', '#FF5F1F');
      root.style.setProperty('--skytec-secondary-dim', 'rgba(255, 95, 31, 0.1)');
      root.style.setProperty('--skytec-accent', '#39FF14');
      root.style.setProperty('--skytec-surface', '#121212');
      root.style.setProperty('--skytec-surface-highlight', '#1E1E1E');
      root.style.setProperty('--skytec-border', '#2A2A2A');
    } else {
      root.classList.remove('dark');
      root.style.setProperty('--usg-bg', '#F5F5F7');
      root.style.setProperty('--usg-fg', '#1E3A5F');
      root.style.setProperty('--usg-primary', '#1E3A5F');
      root.style.setProperty('--usg-primary-dim', 'rgba(30, 58, 95, 0.1)');
      root.style.setProperty('--usg-secondary', '#E67E22');
      root.style.setProperty('--usg-secondary-dim', 'rgba(230, 126, 34, 0.1)');
      root.style.setProperty('--usg-accent', '#27AE60');
      root.style.setProperty('--usg-surface', '#FFFFFF');
      root.style.setProperty('--usg-surface-highlight', '#EEF2F7');
      root.style.setProperty('--usg-border', '#D1D9E6');
      root.style.setProperty('--skytec-bg', '#F5F5F7');
      root.style.setProperty('--skytec-fg', '#1E3A5F');
      root.style.setProperty('--skytec-primary', '#1E3A5F');
      root.style.setProperty('--skytec-primary-dim', 'rgba(30, 58, 95, 0.1)');
      root.style.setProperty('--skytec-secondary', '#E67E22');
      root.style.setProperty('--skytec-secondary-dim', 'rgba(230, 126, 34, 0.1)');
      root.style.setProperty('--skytec-accent', '#27AE60');
      root.style.setProperty('--skytec-surface', '#FFFFFF');
      root.style.setProperty('--skytec-surface-highlight', '#EEF2F7');
      root.style.setProperty('--skytec-border', '#D1D9E6');
    }
    
    localStorage.setItem('usg-theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'light' ? 'dark' : 'light');
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
